import React, { MutableRefObject, useRef, useState } from 'react';
import { EditorLabel } from '../EditorLabel';
import { IEditorProps } from '../Editor';
import { NumericRangeField } from 'components/inputs/data-filters/NumericRangeField';
import { NumericRange, NumericRangeType } from '@decisions/server/DecisionsFramework/Design/Page/Filters';
import { useScopeHandlers } from './hooks/useScopeHandlers';
import { PickButton } from 'components/buttons/PickButton/PickButton';
import { ActionLinks } from 'components/ActionLinks/ActionLinks';
import { Callout } from 'components/layout/Callout';
import { IActionLinkItems } from 'components/ActionLinks/ActionLinkModels';
import {
  getLabelForNumericMatchType,
  getNumericRangeOptions,
} from 'components/inputs/data-filters/utils/NumericRangeUtils';

// import './NumericRangeFilterEditor.less'

export interface INumericRangeFilterEditorProps extends IEditorProps {}

// const getClassName = () => classNames('dpc-numeric-range-filter-editor');

/**
 * Property Editor wrapper for Numeric Range Field
 *
 * Copyright (c) 2020 Decisions All Rights Reserved
 */
export function NumericRangeFilterEditor({ child, path, onChange, hideInputLabel }: INumericRangeFilterEditorProps) {
  const [value, setValue] = useState(child.Value.OutputValue as NumericRange);
  const linkRef: MutableRefObject<HTMLButtonElement | null> = useRef(null);
  const [changingMatchType, setChangingMatchType] = useState(false);
  const toggleMatchTypeOpen = () => {
    setChangingMatchType(!changingMatchType);
  };
  const [matchType, setMatchType] = useState<NumericRangeType>(value.MatchType);

  const onMatchChange = (MatchType: NumericRangeType) => {
    setMatchType(MatchType);
    onValueChange({ ...value, MatchType });
    setChangingMatchType(false);
  };

  const onValueChange = (newValue: NumericRange) => {
    onChange(newValue, path);
    setValue(newValue);
  };

  const currentMatchTypeName = getLabelForNumericMatchType(matchType);

  const matchOptions: IActionLinkItems = {
    current: getNumericRangeOptions(),
  };

  const { personalization } = useScopeHandlers({ value, path, setValue, onChange });

  return (
    <EditorLabel
      editor={child}
      path={path}
      hideInputLabel={hideInputLabel}
      actions={<PickButton onClick={toggleMatchTypeOpen} text={currentMatchTypeName} buttonRef={linkRef} />}
      doNotWrap={true}
    >
      <NumericRangeField value={value} onChange={onValueChange} personalization={personalization} />
      <Callout
        isOpen={changingMatchType}
        onClose={toggleMatchTypeOpen}
        sourceRef={linkRef}
        placement="bottom"
        showArrow={true}
        flipBehavior="counterclockwise"
        open={changingMatchType}
      >
        <ActionLinks values={matchOptions} callback={onMatchChange} />
      </Callout>
    </EditorLabel>
  );
}
